import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const bccolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "ten_cosodaotao",
    headerName: "Cơ sở đào tạo",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "khoa",
    headerName: "Khóa học",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "hang",
    headerName: "Hạng",
    width: 100,
    headerAlign: "center",
  },
  {
    field: "ngaykhaigiang",
    headerName: "Ngày khai giảng",
    width: 150,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "ngaybegiang",
    headerName: "Ngày bế giảng",
    width: 150,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "ngaydangkysathach",
    headerName: "Ngày đăng ký sát hạch",
    width: 180,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "soluonghocvien",
    headerName: "Số lượng học viên",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "soluonggiaovienlythuyet",
    headerName: "SL giáo viên LT",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "soluonggiaovienthuchanh",
    headerName: "SL giáo viên TH",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "soluongxe",
    headerName: "Số lượng xe",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "thoigiandaotao",
    headerName: "Thời gian đào tạo",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "ghichu",
    headerName: "Ghi chú",
    width: 180,
    headerAlign: "center",
  },
];
export default function Thongkequanlydaotao() {
  const [pageSize, setPageSize] = React.useState(50);
  const [tungay, setTungay] = React.useState(dayjs());
  const [denngay, setDenngay] = React.useState(dayjs());
  const [donvi, setDonvi] = React.useState([]);
  const [baocao, setBaocao] = React.useState([]);
  const [donvivalue, setDonvivalue] = React.useState(null);
  const [disableBT, setDisableBT] = React.useState(true);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const getdonvi = () => {
    var url =
      Config.backend + "/api/Donvi/getcosodaotaoall?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setDonvi(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getbaocao = () => {
    var ngaybd =
      tungay.$y +
      "-" +
      String(tungay.$M + 1).padStart(2, "0") +
      "-" +
      tungay.$D;
    var ngaykt =
      denngay.$y +
      "-" +
      String(denngay.$M + 1).padStart(2, "0") +
      "-" +
      denngay.$D;
    var url =
      Config.backend +
      "/api/KhoaHoc/baocaokhoahoc?cosodaotao_id=" +
      donvivalue +
      "&tungay=" +
      ngaybd +
      "&denngay=" +
      ngaykt +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setBaocao(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getdonvi();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Từ ngày"
              value={tungay}
              onChange={(newValue) => setTungay(newValue)}
              format="DD/MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["day", "month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "32px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "15%", marginLeft: 10 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Đến ngày"
              value={denngay}
              onChange={(newValue) => setDenngay(newValue)}
              format="DD/MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["day", "month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "32px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "28%", marginLeft: 10 }}>
          <Autocomplete
            freeSolo
            disableClearable
            size="small"
            options={donvi}
            getOptionLabel={(option) => option.ten}
            onChange={(event, value) => {
              setDisableBT(false);
              setDonvivalue(value.id);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn đơn vị"
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 32 }}
            disabled={disableBT}
            onClick={getbaocao}
          >
            Xem
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.stt}
            rows={baocao}
            columns={bccolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
    </GridContainer>
  );
}
